<template>
    <v-form
        ref="dataFieldStatusForm"
        v-model="formValid"
        lazy-validation>                    
            <v-layout wrap>                
                <v-flex xs9 px-2>                            
                    <v-text-field
                    v-model="name"                     
                    label="Status naam"
                    :rules="[formRules.name]"                         
                    required>
                    </v-text-field>
                </v-flex>   
                <v-flex xs3 px-2>                            
                    <v-text-field
                    v-model="sortOrder"                     
                    label="Volgorde"
                    :rules="[formRules.order]"                         
                    required>
                    </v-text-field>
                </v-flex>                  
                <v-flex xs12 px-2>         
                    <color-picker v-model="color"></color-picker>                                
                </v-flex>                               
                <v-flex xs12 md4 px-2>
                    <v-select 
                    label="Data veld"
                    item-value="id"
                    item-text="customField.name"                                 
                    :items="dataFields"
                    :rules="[formRules.dataField]"                       
                    v-model="dataFieldMapperId"
                    required
                    ></v-select>                                                                
                </v-flex> 
                <v-flex xs12 md4 px-2>
                    <v-select 
                    item-value="internal_name"
                    item-text="label"                                 
                    :items="operators"
                    :rules="[formRules.statusOperator]"   
                    label="Operator type"
                    v-model="statusOperator"
                    required
                    ></v-select>                                                                
                </v-flex> 
                <v-flex xs12 md4 px-2>
                    <v-text-field
                    v-model="statusValue"                     
                    :label="`Afzet waarde ${dataFieldType}`"
                    :rules="[formRules.statusValue]"                         
                    required>
                    </v-text-field>                                                            
                </v-flex>                                
                <v-flex row xs12>
                    <v-layout wrap>
                        <v-switch xs12 md6 v-model="isEvent" label="Status registreren als event"></v-switch>                         
                        <v-flex xs12 md6 px-2 v-if="isEvent">
                            <v-select 
                            item-text="text"                                 
                            :items="eventTypesDd"
                            :rules="[formRules.eventType]"   
                            label="Event soort"
                            v-model="eventTypeId"
                            required
                            ></v-select>                                                                
                        </v-flex>                         
                    </v-layout>
                    <v-flex xs12 v-if="isEvent" py-2>                            
                        <v-textarea
                        v-model="eventShortText"                     
                        label="Korte tekst event (gebruikt voor weergave)"
                        :rules="[formRules.shortText]"
                        required
                        outline>
                        </v-textarea>
                    </v-flex>                               
                </v-flex>                      
                 <v-flex xs12 md6 px-2 v-if="isEvent">                                                                          
                    <label>Wanneer moet dit event registreren?</label>
                    <v-flex xs3 style="min-height:80px;">
                        
                        <v-radio-group v-model="timeTableActive" :mandatory="true">
                        <v-radio label="Altijd" value="no"></v-radio>
                        <v-radio label="Tijdstabel" value="yes"></v-radio>
                        </v-radio-group>                                        
                    </v-flex>                 
                </v-flex>       
                <v-flex v-if="timeTableActive=='yes' && isEvent" xs12 md6>
                    <v-flex px-2>                            
                        <v-select 
                        item-text="text"                                 
                        :items="timeTableZoneDd"
                        label="Kies binnen of buiten periode"
                        v-model="timeTableZone"                
                        ></v-select>             
                    </v-flex>                   
                    <v-flex px-2>                            
                        <v-select 
                        item-text="text"                                 
                        :items="timeTablesDd"
                        label="Kies periode"
                        v-model="timeTableId"                
                        ></v-select>             
                    </v-flex> 
                </v-flex>      
                <v-flex xs12 v-if="isEvent">
                    <v-layout row wrap align-center>
                        <v-flex xs12 md6 px-2>                                                                          
                            <label>Hoe vaak moet dit event registreren?</label>
                            <v-flex xs6 style="min-height:80px;">
                                
                                <v-radio-group v-model="useTriggerAmount" :mandatory="true">
                                <v-radio label="Altijd" value="no"></v-radio>
                                <v-radio label="Met interval" value="yes"></v-radio>
                                </v-radio-group>                                        
                            </v-flex>                                   
                        </v-flex>       
                        <v-flex v-if="useTriggerAmount=='yes' && isEvent" xs12 md6 px-2>
                            <v-text-field
                            v-model="triggerAmount"                     
                            label="Maximaal 1x per (aantal minuten)"
                            :rules="[formRules.triggerAmount]"                         
                            required>
                            </v-text-field>                  
                        </v-flex>                          
                    </v-layout>                    
                </v-flex>                                                                           
                <v-flex row xs12>      
                    <v-layout wrap>
                        <v-btn
                            @click="cancel()"                          
                            color=""> 
                            Annuleren
                        </v-btn>                                                                                                         
                        <v-spacer></v-spacer>                                                                        
                        <v-btn                                                
                            color="success"
                            @click="save()">
                            Opslaan
                        </v-btn>                        
                    </v-layout>                                                                    
                </v-flex>  
            </v-layout>                                     
        </v-form>    
</template>
<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import { Swatches } from 'vue-color'
    import _ from 'lodash';
    import ColorPicker from "../../components/form/ColorPicker"

    export default{
        components:{
            ColorPicker
        },
        data(){
            return {
                useTriggerAmount:"no",
                triggerAmount:null,
                timeTableActive:"no",
                timeTableZone:"",
                timeTableId:null,
                eventId:null,
                eventShortText:"",
                eventTypeId:null,
                isEvent:false,
                id:null,
                sortOrder:0, 
                name:"",
                dataFieldMapperId:null,
                color:null,
                statusValue:null,
                statusOperator:null,
                formValid:true,
                formRules:{
                    name:(value) => {return (value) ? true : "Veld verplicht"},         
                    dataField:(value) => {return (value) ? true : "Veld verplicht"},      
                    statusValue:(value) => {return (value) ? true : "Veld verplicht"},      
                    statusOperator:(value) => {return (value) ? true : "Veld verplicht"},      
                    order:(value) => {return (value) ? true : "Veld verplicht"},
                    shortText:(value) => {return (value) ? true : "Veld verplicht"},
                    eventType:(value) => {return (value) ? true : "Veld verplicht"},     
                    triggerAmount:(value) => {return (value) ? true : "Veld verplicht"},                                                            
                },
            }
        },
        computed: {
            ...mapGetters({
                dataFields: types.UNIT_TYPE_DATA_FIELDS,        
                operators: types.HD_OPERATORS,
                eventTypes: types.EVENT_TYPES,
                eventSeverities: types.EVENT_SEVERITIES,
                timeTables: types.TIME_TABLES,
                predefinedEvents: types.PREDEFINED_EVENTS
            }),
            eventTypesDd(){
                let ts =  this.eventTypes.map((ele) => {                            
                    return {text: ele.name, value: ele.id}
                })
                return (ts !== null) ? ts : []                
            },            
            dataFieldType(){
                let item = ""
                this.dataFields.forEach((field) => {                     
                    if(field.id == this.dataFieldId){
                        item = " in "+field.customField.name
                        if(field.customField.type.shortName)
                            item += " ("+field.customField.type.shortName+")"
                    }
                })
                return item
            },
            defaultSeverityId(){
                let el = this.eventSeverities.find((ele) => {

                            return ele.internalName == "irrelavant"
                         })     
                return el.id
            },
            timeTableZoneDd(){
                return [{value:"inside",text:"Binnen"},{value:"outside",text:"Buiten"}]
            },
            timeTablesDd(){
                let ts =  this.timeTables.map((ele) => {                            
                    return {text: ele.name, value: ele.id}
                })
                return (ts !== null) ? ts : []                      
            },            
        },
        props:{
            unitTypeId:{
                type:String                
            },
            dataFieldStatus:{
                type:Object
            }
        },
        methods:{
            save(){                         
                if (this.$refs.dataFieldStatusForm.validate()) {                    
                    let save = {}                    
                    save.id                = this.id
                    save.name              = this.name
                    save.color             = this.color
                    save.sort_order        = this.sortOrder
                    save.operator          = this.statusOperator
                    save.value             = this.statusValue
                    save.dataFieldMapperId = this.dataFieldMapperId

                    let vm = this
                   // Default save (no relations required)                    
                    this.$store.dispatch(types.SAVE_DATA_FIELD_STATUS, {data:save} ).then((e) => {                                                                   
                        if(!vm.id){
                            vm.id = e.id                            
                        }  
                        
                        // no event configured and no event was ever configured , then skip
                        if(!vm.eventId && !vm.isEvent){
                            vm.$emit('saved', e)
                        }
                        else{
                            let saveObj = {}                                                    
                            // use event id to save
                            if(vm.eventId)
                                saveObj.id = vm.eventId
                            else{ // new event.... give default properties
                                saveObj.unitTypeId      = vm.unitTypeId
                                saveObj.eventSeverityId = vm.defaultSeverityId
                                saveObj.iotEvent        = true
                            }

                            // if isEvent is false only need to set active to false
                            if(!vm.isEvent){
                                saveObj.active          = false
                            }
                            else{
                                saveObj.eventTypeId       = vm.eventTypeId     
                                saveObj.name              = vm.name
                                saveObj.shortText         = vm.eventShortText                            
                                saveObj.active            = true
                                saveObj.iotCode           = "UPDATE" // TODO: Change to unit type positioning event of the selected unit type
                                saveObj.dataFieldMapperId = vm.dataFieldMapperId
                                saveObj.operator          = vm.statusOperator
                                saveObj.value             = vm.statusValue

                                if(vm.timeTableActive == "yes"){
                                    saveObj.timeTableId   = vm.timeTableId
                                    saveObj.timeTableZone = vm.timeTableZone
                                }
                                else{
                                    saveObj.timeTableZone=null
                                    saveObj.timeTableId=null
                                }

                                if(vm.useTriggerAmount == "yes"){
                                    saveObj.triggerIntervalMinutes   = vm.triggerAmount
                                }
                                else{
                                    saveObj.triggerIntervalMinutes = 0
                                }                                
                            }

                            this.$store.dispatch(types.SAVE_UNIT_TYPE_EVENT, {data:saveObj}).then((e) => {                                
                                // eventId is not known yet
                                if(!vm.eventId){
                                    vm.eventId = e.id
                                    vm.isEvent = true

                                    // Save the event id on the data_field_status
                                    let saveObj2 = {id:vm.id,eventId:vm.eventId}

                                    // if event id is not saved yet... add it to datafieldstatus
                                    vm.$store.dispatch(types.SAVE_DATA_FIELD_STATUS, {data:saveObj2} ).then((e) => {         
                                        vm.$emit('saved', e)
                                    })
                                }
                                else
                                    this.$emit('saved', e)
                            }) 
                        }                   
                    });                                      
                }                 
            },
            cancel(){
                this.$emit('cancelClicked')                    
            },        
            loadBaseUnitTypeEventData(){
                
                if(this.eventTypes.length==0){
                    this.$store.dispatch(types.EVENT_TYPES,{})
                }
                if(this.eventSeverities.length==0){
                    this.$store.dispatch(types.EVENT_SEVERITIES,{})                              
                }
                this.$store.dispatch(types.UNIT_TYPE_DATA_FIELDS, { data:{unit_type_id:this.unitTypeId}, params: {include:"customField.type"} })                   

                
                this.$store.dispatch(types.TIME_TABLES, { params: {} })
            },                      
            loadForm(){
                this.loadBaseUnitTypeEventData()

                if(this.dataFieldStatus){            
                    this.id                   = this.dataFieldStatus.id                            
                    this.name                 = this.dataFieldStatus.name
                    this.sortOrder            = this.dataFieldStatus.sortOrder
                    this.color                = this.dataFieldStatus.color
                    this.dataFieldMapperId    = this.dataFieldStatus.dataField.id                                    
                    this.statusOperator       = this.dataFieldStatus.trigger.operator
                    this.statusValue          = this.dataFieldStatus.trigger.value

                    if(this.dataFieldStatus.event){
                        this.isEvent        = this.dataFieldStatus.event.active
                        this.eventId        = this.dataFieldStatus.event.id
                        this.eventTypeId    = this.dataFieldStatus.event.eventTypeId
                        this.eventShortText = this.dataFieldStatus.event.shortText

                        if(this.dataFieldStatus.event.timeTableId){                            
                            this.timeTableActive="yes"
                            this.timeTableId = this.dataFieldStatus.event.timeTableId
                            this.timeTableZone = this.dataFieldStatus.event.timeTableZone

                        }     
                        if(this.dataFieldStatus.event.triggerIntervalMinutes){           
                            this.useTriggerAmount="yes"
                            this.triggerAmount = this.dataFieldStatus.event.triggerIntervalMinutes
                        }                

                    }
                }             
            }
        },        
        mounted(){
            this.loadForm()         
        }
    }
</script>

<style scoped>

</style>